'use strict';

// Mix Type workspace. The reusable EntityMetadataWorkspace provider renders the record's MetaData blob as the guided
// per-customer metadata form (read-only + inline Edit/Save) underneath the Overview field groups. Reachable as a
// Master List (Materials & Mixes). See source/providers/EntityMetadataWorkspace-Provider.js.
const libEntityMetadataWorkspaceProvider = require('../providers/EntityMetadataWorkspace-Provider.js');

module.exports = {
	Identifier: 'MixTypeWorkspace', Ordinal: 246,
	ProviderClass: libEntityMetadataWorkspaceProvider,
	// Meadow exposes the DB column MetaDataJSON as the field `MetaData`.
	MetadataBlob: { column: 'MetaData', label: 'Mix Type Metadata' },
	Entity: { Name: 'MixType', IDField: 'IDMixType', Collection: 'MixTypes', GUIDField: 'GUIDMixType' },
	Header: { Eyebrow: 'Mix Type', Title: (r) => r.Name || `Mix Type ${r.IDMixType}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/MixType/List' },
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
	],
	FieldGroups:
	[
		{ Name: 'Identity', Fields:
			[
				{ Key: 'Name', Label: 'Name', Wide: true },
				{ Key: 'Code', Label: 'Code', Mono: true },
				{ Key: 'Description', Label: 'Description', Wide: true },
				{ Key: 'ApprovingAgency', Label: 'Approving Agency' },
				{ Key: 'Active', Label: 'Active', Format: 'bool' },
			] },
	],
};
